import { services as auth } from '@/modules/auth';
import { servicesUser as user } from '@/pages/dashboard';
import { services as cadastro } from '@/pages/dashboard/cadastro';

export default {
    auth,
    user,
    cadastro,
}
